export const MAIN_COLOR_RED= "#ec3129"